// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3bPvq","amount":"Amount_amount__1OqTk","tip":"Amount_tip__2OyXz","tipHeader":"Amount_tipHeader__1k8OK","tipsWrap":"Amount_tipsWrap__224ZD"};